import React, { useEffect, useState } from 'react';
import { ApiCall } from './CustomHooks';

const CheckoutComponent = () => {
    const [isScriptLoaded, setIsScriptLoaded] = useState(false);
    const [CheckoutData, setCheckoutData] = useState({});

    useEffect(() => {
        const cssLink = document.createElement('link');
        cssLink.rel = 'stylesheet';
        cssLink.href = `https://pay-checkout-uat.bajajfinserv.in/checkoutjsall-uat/M1100178/1.0.0/checkout.css`;
        document.head.appendChild(cssLink);
        const script = document.createElement('script');
        script.src = `https://pay-checkout-uat.bajajfinserv.in/checkoutjsall-uat/M1100178/1.0.0/checkout.js`;
        script.async = true;
        script.onload = () => {
            setIsScriptLoaded(true);
        };

        document.body.appendChild(script);

        return () => {
            document.head.removeChild(cssLink);
            document.body.removeChild(script);
        };
    }, []);

    const CheckOutTokenApi = async () => {
        let data = await ApiCall('/api/SalesEntryAPI/CheckOut', '')
        setCheckoutData(data)
    }

    const initiateCheckout = () => {
        console.log(window.bfl, 'window.bfl')
        if (!isScriptLoaded) {
            console.error('Checkout script not loaded yet');
            return;
        }
        const initData = {
            token: "b5ddebaf984b4f7eb662115ffef13e55",//CheckoutData.token,
            waProfileData: '',
            key: JSON.stringify({
                curCredentials: {
                    pkcsSalt: '',
                    rsaSalt: '',
                },
            }),
        };
        if (window.bfl && window.bfl.initiate) {
            window.bfl.initiate(initData);
        } else {
            console.error('Bajaj Finserv Checkout JS is not available');
        }
    };


    useEffect(() => {
        //CheckOutTokenApi();
        const handleCheckoutUpdate = (event) => {
            console.log('Payment response:', event.detail);
        };
        window.addEventListener('checkoutUpdate', handleCheckoutUpdate);
        return () => {
            window.removeEventListener('checkoutUpdate', handleCheckoutUpdate);
        };
    }, []);

    return (
        <div>
            <button onClick={initiateCheckout}>Start Checkout</button>
        </div>
    );
};

export default CheckoutComponent;